import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ number, title, testId }) => (
  <Reveal className="flex items-baseline gap-6 mb-16">
    <span className="font-mono-tech text-sm text-[#e65c00] tracking-[0.2em]" data-testid={`${testId}-number`}>
      {number}
    </span>
    <h2 className="font-display font-light text-base md:text-lg tracking-[0.25em] uppercase text-[#8a8a8a]" data-testid={`${testId}-title`}>
      {title}
    </h2>
    <span className="flex-1 h-px bg-white/[0.08] self-center hidden md:block" />
  </Reveal>
);
